import { Box, Card, Dialog, Stack } from '@mui/material';
import { ReactElement, useState, useEffect, useCallback } from 'react';
import {
  Datagrid,
  EditButton,
  TextField,
  useTranslate,
  FunctionField,
  useNotify,
} from 'react-admin';
import { CustomBreadcrumbs } from '../../../../../components/custom-breadcrumbs';
import { DashboardContent } from '../../../../../layouts/dashboard';
import { Resources } from '../../resource';
import { PermissionGuard } from '../../../../../routes/components/permission-guard';
import ErrorPage403 from '../../../../error/403';
import { PermissionButton } from '../../../../../routes/components/permission-button';
import {
  getRedPacketConfigs,
  updateRedPacketConfig,
  RedPacketConfig,
} from '../../../services/redpacketService';
import EditRedPacketConfig from './Edit';



const WithdrawConfigList = () => {
  const translate = useTranslate();
  const notify = useNotify();
  const [popup, setPopup] = useState<ReactElement>();
  const [data, setData] = useState<RedPacketConfig[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      // 获取所有配置项
      const results = await getRedPacketConfigs();
      setData(results);
    } catch (error: any) {
      notify(error.message || translate('module.redpacket.failedToGetData'), { type: 'error' });
      setData([]);
    } finally {
      setLoading(false);
    }
  }, [notify,translate]);

  useEffect(() => {
    fetchData();
  }, [fetchData,translate]);

  return (
    <PermissionGuard resource="redpacket" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent>
        <CustomBreadcrumbs
          heading={translate('module.redpacket.redPacketConfig')}
          links={[
            { name: translate('module.redpacket.redPacketManagement'), href: `/${Resources.redpacket}` },
            { name: translate('module.redpacket.redPacketConfig') },
          ]}
        />

        <Card sx={{ mt: 3, pb: 2 }}>
          <Box sx={{ overflow: 'auto' }}>
            <Datagrid rowClick={false} data={data} isLoading={loading} bulkActionButtons={false}>
              <FunctionField
                label={translate('module.redpacket.configKey')}
                render={(record: RedPacketConfig) => record.configKey}
              />
              <TextField source="value" label={translate('module.redpacket.value')} />
              <TextField source="description" label={translate('module.redpacket.descriptionCol')} />
              <FunctionField
                label={translate('module.redpacket.updatedAtCol')}
                render={(record: RedPacketConfig) => {
                  const date = record.updatedAt;
                  return date ? new Date(date).toLocaleString() : '-';
                }}
              />
              <FunctionField
                label={translate('module.redpacket.operation')}
                render={(record: RedPacketConfig) => (
                  <Stack direction="row" spacing={1}>
                    <PermissionButton resource="redpacket" action="update">
                      <EditButton
                        onClick={(e) => {
                          e.stopPropagation();
                          setPopup(
                            <EditRedPacketConfig
                              id={record.id}
                              record={record}
                              onClose={() => {
                                setPopup(undefined);
                                fetchData();
                              }}
                            />
                          );
                        }}
                      />
                    </PermissionButton>
                  </Stack>
                )}
              />
            </Datagrid>
          </Box>
        </Card>

        {popup && (
          <Dialog open maxWidth="md" fullWidth>
            {popup}
          </Dialog>
        )}
      </DashboardContent>
    </PermissionGuard>
  );
};

export default WithdrawConfigList;
